import Modal from 'bootstrap/js/dist/modal'

// @vue/component
export default {
  name: 'BaseModal',

  props: {
    /** Whether to hide the modal footer */
    hideFooter: {
      type: Boolean,
      default: false,
    },
    /** Whether to hide the modal header */
    hideHeader: {
      type: Boolean,
      default: false,
    },
    /** Whether to vertically center the modal */
    centered: {
      type: Boolean,
      default: false,
    },
    /** The modal title text */
    title: {
      type: String,
      default: 'Modal title',
    },
    /** Whether to disable focus trapping */
    noFocus: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['hidden', 'close'],

  data() {
    return {
      modalElem: null,
    }
  },

  mounted() {
    this.modalElem = Modal.getOrCreateInstance(this.$refs.modal, {
      focus: !this.noFocus,
    })
    this.$refs.modal.addEventListener('hide.bs.modal', () =>
      this.onModalClose()
    )
    this.$refs.modal.addEventListener('hidden.bs.modal', () =>
      this.modalHidden()
    )
  },

  beforeUnmount() {
    this.close()

    this.$refs.modal.removeEventListener('hide.bs.modal', this.onModalClose)
    this.$refs.modal.removeEventListener('hidden.bs.modal', this.modalHidden)
  },

  methods: {
    /** Shows the modal. */
    open() {
      if (this.modalElem) {
        this.modalElem.show()
      }
    },

    /** Hides the modal. */
    close() {
      if (this.modalElem) {
        this.modalElem.hide()
      }
    },

    /**
     * Emits a 'close' event when the modal is closed.
     */
    onModalClose() {
      this.$emit('close')
    },

    /**
     * Emits a 'hidden' event when the modal is fully hidden.
     */
    modalHidden() {
      this.$emit('hidden')
    },
  },
}
